export default __webpack_public_path__ + "static/gilroy-light-25b04da86fcec454d24b30cadd113799.woff";